import React from 'react';
import Alarm from '@material-ui/icons/Alarm';
import {
  KeyboardTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ptBR from 'date-fns/locale/pt-BR';

const CustomTimePicker = props =>
  (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
      <KeyboardTimePicker
        // mask={[/\d/, /\d/, ':', /\d/, /\d/]}
        clearable
        clearLabel="Limpar"
        placeholder="HH:MM"
        invalidDateMessage="Hora inválida"
        ampm={false}
        keyboardIcon={<Alarm />}
        keyboard
        required
        disableOpenOnEnter
        cancelLabel="Cancelar"
        okLabel="Confirmar"
        {...props}
      />
    </MuiPickersUtilsProvider>
  );

export default CustomTimePicker;
